import type { IconProps } from './types';
import './icons.css';

export default function Agreements({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 24}
      height={height || 24}
      viewBox="0 0 24 24"
      className={`icon icon-arrow-down ${className || ''}`}
    >
      <path
        fill="currentColor"
        d="M3.75 2A1.75 1.75 0 0 0 2 3.75v16c0 .966.784 1.75 1.75 1.75h12a1.75 1.75 0 0 0 1.75-1.75v-3.903l-1.15 1.15a4.093 4.093 0 0 1-.35.282v2.471a.25.25 0 0 1-.25.25h-12a.25.25 0 0 1-.25-.25v-16a.25.25 0 0 1 .25-.25h6.75v4.75c0 .966.784 1.75 1.75 1.75h.616l1.5-1.5H12.25a.25.25 0 0 1-.25-.25V4.908l2.827 3.131.963-.963a2.21 2.21 0 0 1 .102-.096l-3.975-4.403A1.75 1.75 0 0 0 10.618 2H3.75Z"
      />
      <path
        fill="currentColor"
        d="M10.634 12.5H6.75a.75.75 0 0 0 0 1.5h3.364l.136-.75c.022-.093.197-.423.384-.75ZM6.75 16h3l-.273 1.5H6.75a.75.75 0 0 1 0-1.5Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="m20.74 10.124-.591.118a2.162 2.162 0 0 1-.627 1.69l-4.265 4.265a1.75 1.75 0 0 1-.867.473l-3.559.77.771-3.558a1.75 1.75 0 0 1 .473-.867L16.34 8.75a2.162 2.162 0 0 1 1.69-.627l.118-.592A1.49 1.49 0 0 1 19.4 6.348a2.232 2.232 0 0 1 2.525 2.525 1.491 1.491 0 0 1-1.183 1.25Zm-1.247-1.669.125-.623a.732.732 0 0 1 .822.822l-.623.125a1.452 1.452 0 0 0-.581.257 1.45 1.45 0 0 0 .257-.58ZM17.93 9.62c.37.034.723-.073 1.002-.28-.207.279-.314.632-.28 1.002a.663.663 0 0 1-.191.53l-4.265 4.264a.25.25 0 0 1-.124.068l-1.282.278.278-1.282a.25.25 0 0 1 .068-.124L17.4 9.81c.14-.14.334-.21.53-.191Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
